<template>
  <div id="configuracoesSistema" class="vs-con-loading__container w-full">
    <vs-table
        :data="configuracoesFiltradas"
        max-items="10"
        maxHeight="60vh"
        noDataText="Nenhuma variável de sistema cadastrada"
        pagination
        search
    >
      <template slot="header">
        <vs-row vs-align="center" vs-type="flex" vs-w="12">
          <vs-col vs-w="5">
            <h4 style="color: #b4aa99">Variáveis de Sistema</h4>
          </vs-col>
          <vs-col vs-w="4">
            <vs-select
                v-model="categoriaSelecionada"
                autocomplete
                class="w-full"
                label="Categoria"
                placeholder="Todas"
            >
              <vs-select-item
                  v-for="(item, index) in opcoesCategoria"
                  :key="index"
                  :text="item"
                  :value="item"
              />
            </vs-select>
          </vs-col>
          <vs-col
              vs-align="center"
              vs-justify="flex-end"
              vs-type="flex"
              vs-w="3"
          >
            <ModalConfiguracaoSistema
                :categorias="categorias"
                modo="cadastro"
                @update="getConfiguracoes"
            />
          </vs-col>
        </vs-row>
      </template>

      <template slot="thead">
        <vs-th class="col-chave" sort-key="chave">Chave</vs-th>
        <vs-th class="col-categoria" sort-key="categoria">Categoria</vs-th>
        <vs-th class="col-valor" sort-key="valor">Valor</vs-th>
        <vs-th class="col-descricao" sort-key="descricao">Descrição</vs-th>
        <vs-th class="col-acoes">Ações</vs-th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr v-for="(tr, indextr) in data" :key="indextr">
          <vs-td :data="data[indextr].chave">
            <span class="font-bold">{{ data[indextr].chave }}</span>
          </vs-td>

          <vs-td :data="data[indextr].categoria">
            <vs-chip color="primary">{{ data[indextr].categoria }}</vs-chip>
          </vs-td>

          <vs-td :data="data[indextr].valor">
            <div class="flex items-center">
              <span class="valor-configuracao">{{
                  valorExibido(data[indextr])
                }}</span>
              <vs-button
                  v-if="ehSensivel(data[indextr].chave)"
                  :icon="
                  chavesReveladas.includes(data[indextr].chave)
                    ? 'visibility_off'
                    : 'visibility'
                "
                  class="ml-2"
                  color="dark"
                  icon-pack="material-icons"
                  radius
                  size="small"
                  type="flat"
                  @click="alternarVisibilidade(data[indextr].chave)"
              ></vs-button>
            </div>
          </vs-td>

          <vs-td :data="data[indextr].descricao">{{
              data[indextr].descricao || "-"
            }}
          </vs-td>

          <vs-td>
            <ModalConfiguracaoSistema
                :categorias="categorias"
                :configuracao="data[indextr]"
                modo="edicao"
                @update="getConfiguracoes"
            />
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </div>
</template>

<script>
import components from "@/components/default/exports.js";
import ConfiguracaoSistemaService from "@/services/ConfiguracaoSistemaService.js";
import ModalConfiguracaoSistema from "./modal.vue";

const TODAS = "Todas";

export default {
  name: "ListaConfiguracaoSistema",
  data () {
    return {
      configuracoes: [],
      categoriaSelecionada: TODAS,
      chavesReveladas: []
    };
  },
  computed: {
    categorias () {
      const encontradas = this.configuracoes.map(item => item.categoria);
      return [...new Set(encontradas)].sort();
    },
    opcoesCategoria () {
      return [TODAS, ...this.categorias];
    },
    configuracoesFiltradas () {
      if (this.categoriaSelecionada === TODAS) return this.configuracoes;
      return this.configuracoes.filter(
          item => item.categoria === this.categoriaSelecionada
      );
    }
  },
  methods: {
    async getConfiguracoes () {
      await this.$vs.loading({
        container: "#configuracoesSistema",
        scale: 0.6
      });
      try {
        const res = await ConfiguracaoSistemaService.listar();
        this.configuracoes = res.map(item => ({
          ...item,
          categoria: ConfiguracaoSistemaService.categoriaDaChave(item.chave)
        }));
        this.chavesReveladas = [];
        if (!this.categorias.includes(this.categoriaSelecionada)) {
          this.categoriaSelecionada = TODAS;
        }
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if (error.code == 401) {
          await window.localStorage.clear();
          await this.$router.push("/");
        }
      } finally {
        await this.$vs.loading.close("#configuracoesSistema > .con-vs-loading");
      }
    },
    ehSensivel (chave) {
      return ConfiguracaoSistemaService.ehSensivel(chave);
    },
    valorExibido (configuracao) {
      if (this.chavesReveladas.includes(configuracao.chave)) {
        return configuracao.valor || "-";
      }
      return ConfiguracaoSistemaService.formatarValor(
          configuracao.chave,
          configuracao.valor
      );
    },
    alternarVisibilidade (chave) {
      if (this.chavesReveladas.includes(chave)) {
        this.chavesReveladas = this.chavesReveladas.filter(
            item => item !== chave
        );
      } else {
        this.chavesReveladas = [...this.chavesReveladas, chave];
      }
    }
  },
  components: {
    ...components,
    ModalConfiguracaoSistema
  },
  async mounted () {
    await this.getConfiguracoes();
  }
};
</script>

<style scoped>
.valor-configuracao {
  font-family: monospace;
  font-size: 0.85rem;
  overflow-wrap: anywhere;
}
</style>

<style lang="scss">
/* Sem `scoped`: a vs-table renderiza thead/tbody fora do escopo do componente.
   Sem larguras explicitas a coluna Chave ocupa quase toda a linha e o Valor
   quebra caractere a caractere. */
#configuracoesSistema {
  .vs-table--thead th.col-chave,
  .vs-table--tbody-table tr td:nth-child(1) {
    width: 22%;
  }

  .vs-table--thead th.col-categoria,
  .vs-table--tbody-table tr td:nth-child(2) {
    width: 10%;
  }

  .vs-table--thead th.col-valor,
  .vs-table--tbody-table tr td:nth-child(3) {
    width: 33%;
  }

  .vs-table--thead th.col-descricao,
  .vs-table--tbody-table tr td:nth-child(4) {
    width: 25%;
  }

  .vs-table--thead th.col-acoes,
  .vs-table--tbody-table tr td:nth-child(5) {
    width: 10%;
    text-align: center;
  }

  .vs-table--tbody-table tr td {
    vertical-align: middle;
  }
}
</style>
